<template>
    <div>
        <div v-if="type && task">
            <!--            new address-->
            <div v-if="type == 5">
                <div class="row">
                    <div class="col-md-8">
                        <h5 class="alert alert-info">Смена адреса доставки - курьер: <strong>{{task.user.name}}</strong></h5>
                        <p>Новый адрес: <strong>{{task.text_data}}</strong></p>

                        <div class="form-group flex runners_select">
                            <div>
                                <input class="form-check-input" type="radio" v-model="runner_opt" id="inlineRadio1" value="1">
                                <label class="form-check-label" for="inlineRadio1">Оставить за курьером</label>
                            </div>
<!--                            <div>-->
<!--                                <input class="form-check-input" type="radio" v-model="runner_opt" id="inlineRadio2" value="2">-->
<!--                                <label class="form-check-label" for="inlineRadio2">Передать курьеру</label>-->
<!--                            </div>-->
                            <div>
                                <input class="form-check-input" type="radio" v-model="runner_opt" id="inlineRadio3" value="3">
                                <label class="form-check-label" for="inlineRadio3">Сбросить заявку</label>
                            </div>
                        </div>
<!--                        <select :disabled="!(runner_opt == 2)" class="form-control" v-model="selected_runner">-->
<!--                            <option v-for="(runner, index) in runners" :value="index">{{runner}}</option>-->
<!--                        </select>-->
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Стоимость доставки</label>
                                    <input @change="updatePrice" type="number" v-model="task.order.dost_price" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Скидка</label>
                                    <div class="input-group">
                                        <input @change="updatePrice" type="number" v-model="task.order.discount" class="form-control">
                                        <div class="input-group-append">
                                            <select @change="updatePrice" class="form-control" v-model="task.order.discount_type">
                                                <option value="0">Руб</option>
                                                <option value="1">%</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="">Стоимость заявки</label>
                            <input type="number" disabled :value="task.order.total_price" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-12 text-right">
                        <button @click="makeTaskAction" class="btn btn-success">Подтвердить</button>
                    </div>
                </div>
            </div>

            <div v-if="type == 4">
                <div class="row">
                    <div class="col-md-8">
                        <h5 class="alert alert-info">Смена количества препарата - курьер: <strong>{{task.user.name}}</strong></h5>
                        <p>Перапарат: <strong>{{getDrugNameById(task.text_data)}} - {{task.num_data}}</strong> шт</p>
                        <p>В наличии на складе: <strong>{{inStores[task.order.city][task.text_data]}}</strong> шт</p>
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Стоимость доставки</label>
                                    <input @change="updatePrice" type="number" v-model="task.order.dost_price" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Скидка</label>
                                    <div class="input-group">
                                        <input @change="updatePrice" type="number" v-model="task.order.discount" class="form-control">
                                        <div class="input-group-append">
                                            <select @change="updatePrice" class="form-control" v-model="task.order.discount_type">
                                                <option value="0">Руб</option>
                                                <option value="1">%</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-8">
                        <div class="form-group">
                            <label for="">Новая стоимость заявки</label>
                            <input type="number" disabled :value="task.order.total_price" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Старая стоимость заявки</label>
                            <input type="number" disabled :value="oldPrice" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-8">
                        <div class="input-group">
                            <input type="text" v-model="task.system_comments" placeholder="Причина отказа на запрос" class="form-control">
                            <div class="input-group-append">
                                <button @click="makeTaskAction($event, 'reject')" class="btn btn-warning" type="button">Отказать</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 text-right">
                        <button @click="makeTaskAction($event)" class="btn btn-success">Подтвердить</button>
                    </div>
                </div>
            </div>

            <div v-if="type == 3">
                <div class="row">
                    <div class="col-md-6">
                        <h5 class="alert alert-warning">Отмена заявки</h5>
                        <p>Причина: <strong>{{task.text_data}}</strong></p>
                    </div>
                    <div class="col-md-6 text-right">
                        <button @click="makeTaskAction($event)" class="btn btn-info">Подтвердить</button>
                    </div>
                </div>
            </div>

            <div v-if="type == 2">
                <div class="row">
                    <div class="col-md-6">
                        <h5 class="alert alert-warning">Перенос заявки</h5>
                        <p>Новая дата доставки: <strong>{{task.text_data}}</strong></p>
                    </div>
                    <div class="col-md-6 text-right">
                        <button @click="makeTaskAction($event)" class="btn btn-info">Ознакомлен</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import api from '@/api';

    export default {
        data() {
            return {
                Toast: this.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }),
                selected_runner: null,
                originalPrice: 0,
                runner_opt: 1,
            }
        },
        props: [
            'type', 'task', 'runners', 'inStores'
        ],
        watch: {
            task() {
                this.updateFigures();
            }
        },
        methods: {
            updatePrice() {
                let disc = 0;
                if (this.task.order.discount_type == 0) {
                    disc = this.task.order.discount || 0;
                } else {
                    disc = Math.round((this.originalPrice * this.task.order.discount / 100)) || 0;
                }
                let delivery = this.task.order.dost_price || 0;
                this.task.order.total_price = +this.originalPrice + +delivery - +disc;
            },
            getDrugNameById(prepId) {
                let name;
                this.task.order.preps.forEach((p) => {
                    if (p.prep == prepId) {
                        name = p.drug.prep;
                        return;
                    }
                });
                return name;
            },
            calculateNewPrice() {
                let total = 0;
                this.task.order.preps.forEach((p) => {
                    if (p.prep == this.task.text_data) {
                        total += (p.prep_price * this.task.num_data);
                    } else {
                        total += (p.prep_price * p.num);
                    }
                });
                this.originalPrice = total;
                this.updatePrice();
            },
            async makeTaskAction(e, action = null) {
                e.target.disabled = true;
                var myPromise = new Promise(async (resolve, reject) => {
                    if (this.type == 5) {
                        let {data} = await api.store('/runners/makeTaskAction', {
                            task_id: this.task.id,
                            type: this.type,
                            runner_opt: this.runner_opt,
                            selected_runner: this.selected_runner,
                            order: this.task.order
                        });
                        resolve(data);
                        return;
                    }

                    if (this.type == 4) {
                        if (action && action == 'reject'){
                            console.log(this.task.system_comments);
                            if (!this.task.system_comments || this.task.system_comments.length < 5){
                                resolve({success: false, 'message': 'Укажите причину отказа, менее 5-ти символов'});
                                return;
                            }
                        }
                        let {data} = await api.store('/runners/makeTaskAction', {
                            task_id: this.task.id,
                            system_comments: this.task.system_comments,
                            type: this.type,
                            reject_action: action == 'reject' ? true : false,
                            order: this.task.order,
                        });
                        resolve(data);
                        return;
                    }

                    if (this.type == 3 || this.type == 2) {
                        // console.log(this.task.id, this.task.order.id);
                        let {data} = await api.store('/runners/makeTaskAction', {
                            task_id: this.task.id,
                            type: this.type,
                            order_id: this.task.order.id
                        });
                        resolve(data);
                        // resolve({success:true});
                        return;
                    }

                    resolve({success: false});
                });

                const data = await myPromise;

                if (data.success) {

                    await this.$emit('updateTasks', this.task.id, this.type);
                    this.Toast.fire({
                        type: 'success',
                        title: 'Сохранено'
                    })
                    // this.task = null;
                } else {
                    this.Toast.fire({
                        type: 'warning',
                        title: data.message || 'Ошибка'
                    })
                }
                e.target.disabled = false;
            },
            updateFigures() {
                this.originalPrice = this.task.order.total_price;
                this.oldPrice = this.task.order.total_price;

                if (this.type == 4) {
                    this.calculateNewPrice();
                }

                if (this.type == 5)
                    this.updatePrice();
            }
        },
        created() {
            this.updateFigures();
        }

    }
</script>


<style>
    .alert {
        padding: 10px 20px;
    }

    .flex {
        display: flex;
    }

    .runners_select label {
        margin-bottom: 0;
        align-self: center;
        padding-left: 10px;
    }

    .runners_select {
        flex-direction: column;
        padding-left: 20px;
    }

    .runners_select .form-check-input:focus {
        box-shadow: none;
    }

</style>
